import {get, post } from './http'
// 儿童列表
export const listByParentId = (params) => {
        return get('/min-program/v1/child/listByOpenIds', params);
    }
    // 儿童列表(带积分和任务数量)
export const listChildInfo = (params) => {
        return get('/min-program/v1/child/listChildInfo' + params);
    }
    // 绑定手表
export const bind = (params) => {
        return post('/min-program/v1/child/bind', params);
    }
    // 儿童能力树信息
export const getChildAbility = (params) => {
        return get('/min-program/v1/child/getChildAbility', params);
    }
    // 解绑
export const unbind = (id) => {
        return post('/min-program/v1/child/unbind/' + id, '');
    }
    // 修改配置信息
export const updateConfig = (params) => {
        return post('/min-program/v1/child/updateConfig', params);
    }
    // 修改昵称
export const updateName = (params) => {
    return post('/min-program/v1/child/updateName', params);
}